// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import AssistantActivity from '@app/features/konvo_assistant/state/AssistantActivity';
import {parseMemoryEvent} from '@app/features/konvo_corner/state/CornerMemoryQueue';

export function handleKonvoAssistantActivity(data: unknown, _context: GatewayHandlerContext): void {
	if (!data || typeof data !== 'object') return;
	// The assistant saved a note about me: the corner says "I'll remember that" (no label, no running).
	if ('memory' in data) {
		const note = parseMemoryEvent(data, Date.now());
		// Loaded on first use: the corner store pulls in the panel and REST stores this handler doesn't need.
		if (note)
			void import('@app/features/konvo_corner/state/CornerMemory').then(({default: memory}) => memory.receive(note));
		return;
	}
	const event = data as {label?: unknown; running?: unknown};
	// Heartbeats carry only `running`; they must not wipe the label of the tool in progress.
	if ('label' in event) AssistantActivity.set(typeof event.label === 'string' ? event.label : null);
	if (typeof event.running === 'boolean') AssistantActivity.setRunning(event.running);
}
